import React, { useContext } from 'react';
import OnHoverTooltip from '../shared/OnHoverTooltip';
import { useTranslation } from 'react-i18next';
import { RESET_FILTERS_TOOLTIP } from '../../../i18n/keyConstants';

const FilterResetter = ({ DataContext }) => {
    const { dispatch } = useContext(DataContext);
    const { t } = useTranslation(['shared']);
    const handleClick = () => {
        dispatch({ type: 'RESET_FILTERS' });
    };

    const content = (
        <div id='filter-resetter' className='d-flex ml-auto my-auto'>
            <div className='btn-group'>
                <OnHoverTooltip
                    labelClassNames='no-bottom-margin'
                    dataFor='filterResetter'
                    tooltipType='light'
                    tooltipPlace='top'
                    tooltipEffect='solid'>

                    <button
                        type='button'
                        className='btn btn-outline-secondary border-0'
                        onClick={() => handleClick()}>
                        <span className='oi oi-reload'></span>
                    </button>
                    <span>{t(RESET_FILTERS_TOOLTIP)}</span>

                </OnHoverTooltip>
            </div>
        </div>
    );
    return content;
};

export default FilterResetter;